<template>
  <div>
    <div class="main">
      <div class="footer-bg-holder">
        <div class="footer__main">
          <div class="footer__container">
            <div class="footer__containerbody">
              <div class="footer__body" v-for="item in footer" :key="item.id">
                <h3>{{ item.name }}</h3>
                <div v-for="link in item.links" :key="link.id">
                  <a
                    :href="link.url"
                    target="_blank"
                    :style="{ color: 'white', padding: '5px 0px 5px 0px' }"
                    class="footer__content"
                  >
                    <span>{{ link.name }}</span></a
                  >
                </div>
              </div>
              <div class="footer__body">
                <h3>Locations</h3>
                <div class="footer__content">
                  <span
                    :style="{ color: 'white', padding: '5px 0px 5px 0px' }"
                    @click="handleLocationChange(1)"
                  >
                    Kathmandu</span
                  >
                  <span
                    :style="{ color: 'white', padding: '5px 0px 5px 0px' }"
                    @click="handleLocationChange(2)"
                    >Pokhara</span
                  >
                </div>
              </div>
              <!-- <div class="footer__body">
                <h3>Services</h3>
                <div class="footer__content">
                  <span> State of Art Kitchen</span>
                  <span>24 Hour Delivery</span>
                  <span>Full Fledged Mart</span>
                  <span>Stall & Outdoor Catering</span>

                  <span>Food Event Category</span>
                  <span>Food Subscription</span>
                </div>
              </div> -->
            </div>

            <!-- <div class="footer__containerbody">
              <div class="footer__body">
                <h3>For Business</h3>
                <div class="footer__content">
                  <span> Coupon</span>
                  <span>Lunch & Cakes</span>
                  <span>Gift Packs</span>
                  <span> Food Vouchers</span>
                  <span>Collaborations</span>
                </div>
              </div>
              <div class="footer__body">
                <h3>Locations</h3>
                <div class="footer__content">
                  <span @click="handleLocationChange(1)"> Kathmandu</span>
                  <span @click="handleLocationChange(2)">Pokhara</span>
                </div>
              </div>
            </div> -->
          </div>

          <div class="footer__socials">
            <div>
              <a
                href="https://facebook.com/khaanpinfoods"
                target="_blank"
                class="footer__socialIcons"
              >
                <img
                  :src="require('../../assets/socials/facebook.png')"
                  :style="{ borderRadius: '8px' }"
              /></a>

              <a
                href="https://instagram.com/khaanpin"
                target="_blank"
                class="footer__socialIcons"
              >
                <img
                  :src="require('../../assets/socials/instagram.png')"
                  :style="{ marginLeft: '3px', borderRadius: '6px' }"
                />
              </a>

              <a
                href="https://twitter.com/khaanpin"
                target="_blank"
                class="footer__socialIcons"
              >
                <img :src="require('../../assets/socials/twitter.png')" />
              </a>
            </div>
            <div class="footer__newsletter">
              <span>Subscribe to Newsletter</span>
              <div>
                <form class="footer__subscribe">
                  <input placeholder="Email / Phone" v-model="subscribeText" />
                  <button @click="handleSubscribe">Subscribe</button>
                </form>
              </div>
            </div>
            <div>
              <a
                href="https://khaanpin.com.np/app/"
                target="_blank"
                class="footer__download"
              >
                <img :src="require('../../assets/socials/applestore.svg')" />
                <img :src="require('../../assets/socials/playstore.png')" />
              </a>
            </div>

            

          </div>
        </div>
      </div>
      <div class="bottom-padding"></div>
    </div>
  
    <div class="main">
      <div class="footer-bg-holder">

        <div class="links-holder">
        <a href="http://khaanpin.com/faq" target="_blank">FAQ</a> | <a href="http://khaanpin.com/refund" target="_blank">Refund Policies</a> 
        <!-- | <a href="http://khaanpin.com/jobs" target="_blank">Jobs</a> -->
      </div>

        <div class="footer__versions">
          <span>© Khaanpin 2023</span>
          <span>0.3.16.1</span>
          
        </div>

        

      </div>

      
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import router from "../../router";

export default {
  name: "Footer",

  data() {
    return {
      subscribeText: "",
      footer: [],
    };
  },

  computed: {
    ...mapGetters(["loggedIn", "loggedInApp"]),
  },
  created() {
    axios
      .get("https://deus.khaanpin.com/appapi/footer/")
      .then((res) => {
        if (!res.data.error) {
          this.footer = res.data.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    ...mapActions(["updateLocationId", "clearCart"]),

    handleLocationChange: function (loc) {
      if (`${loc}` == 1) {
        this.updateLocationId(1);
        this.clearCart();
        this.$router.push("/ktm");
        window.location.reload();
      } else if (`${loc}` == 2) {
        this.updateLocationId(2);
        this.clearCart();

        this.$router.push("/pkr");
        window.location.reload();
      }
    },

    handleSubscribe(e) {
      e.preventDefault();
      if (!this.subscribeText) {
        return;
      }
      if (this.loggedIn || this.loggedInApp) {
        router.push("/p/profile");
      } else {
        router.push("/register");
      }
    },

    getApp() {
      window.location.href("https://khaanpin.com.np/app/");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat&family=Roboto:wght@500&display=swap");

.links-holder{
  background-image: url(../../assets/background/footer.png);

    text-align:center;
    color:#FFF;
    /* background:transparent; */
    margin-bottom:20px;
  }
  .links-holder a{
    text-align:center;
    color:#FFF !important;
    background:transparent;
  }


.main {
  /* background: url("../assets/background/footer.png"); */
  position: relative;
  /* display: none; */
  /* margin-top: 5%; */
}

.footer-bg-holder {
  background: #ed2027;
}

.footer__main {
  padding: 3rem 5rem 15px 5rem;
  min-height: 40vh;
  background-image: url(../../assets/background/footer.png);
  font-weight: bold;
  color: #ffffff;
  /* margin-top: 10px; */
  font-family: "Montserrat", sans-serif;
  width: 100%;
  height: 100%;
  /* margin-top: 6%; */
}

.footer__container {
  /* border: 1px solid black; */
  display: flex;
  /* flex-direction: row;
  justify-content: space-between; */
}

.footer__containerbody {
  display: flex;
  flex: 6;
  justify-content: space-around;
}

.footer__body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.footer__body > h3 {
  color: #ffffff;
  font-size: 21px;
  font-weight: bolder;
  margin-bottom: 23px;
}

.footer__content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.footer__content > span {
  font-size: 14px;
  line-height: 1.1rem;
  letter-spacing: 0.8px;
}

.footer__content > span:hover {
  text-decoration: underline;
  cursor: pointer;
}

.footer__socials {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;
}

.footer__socialIcons > img {
  height: 45px;
  margin: 3px;
}

.footer__newsletter {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer__newsletter > span {
  font-family: "Montserrat", sans-serif;
  font-size: 18px;
  letter-spacing: 0.5px;
}

.footer__subscribe {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 6px;
}

.footer__subscribe > input {
  outline: none;
  width: 21rem;
  height: 2.3rem;
  border: none;
  border-radius: 20px;
  font-family: "Montserrat", sans-serif;
  color: #161616;
  font-size: 16px;
  padding-left: 0.8rem;
}

.footer__subscribe > button {
  color: #ffffff;
  background-color: transparent;
  border: 1px solid #ffffff;
  margin-left: 8px;
  height: 2.3rem;
  padding: 0 1.3rem;
  border-radius: 20px;
  font-weight: bolder;
  letter-spacing: 0.8px;
  cursor: pointer;
}

::placeholder {
  color: #444444;
}

.footer__subscribe > button:hover {
  background-color: #ff0000;
  transition: 0.3s all;
}

.footer__download {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.footer__download > img:nth-child(1) {
  margin: 0.6rem;
  height: 55px;
  cursor: pointer;
}
.footer__download > img:nth-child(2) {
  margin: 0.4rem;

  height: 80px;
  cursor: pointer;
}

.footer__versions {
  /* background-color: #dd3300; */
  background: url("../../assets/background/footer.png");

  padding: 0.5rem 5rem 95px 5rem;

  border-top: 1px solid #e2e2e2;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Montserrat", sans-serif;
}

.footer__versions span:nth-child(1) {
  font-weight: bolder;
  letter-spacing: 0.5px;
}

.footer__versions span:nth-child(2) {
  font-size: 10px;
  font-weight: bolder;
  letter-spacing: 0.5px;
}

@media only screen and (max-width: 1180px) {
  .footer__socials {
    display: flex;
    flex-direction: column;
  }

  .footer__newsletter {
    margin: 20px 0;
  }

  @media only screen and (max-width: 555px) {
    .footer__subscribe {
      display: flex;
      flex-direction: column;
    }

    .footer__subscribe > button {
      margin-top: 16px;
    }
    .footer__download > img:nth-child(1) {
      margin: 0.4rem;
      height: 45px;
      cursor: pointer;
    }
    .footer__download > img:nth-child(2) {
      margin: 0.2rem;

      height: 70px;
      cursor: pointer;
    }
  }
  @media only screen and (max-width: 1200px) {
    .footer__container {
      display: flex;
      flex-direction: column;
    }

    .footer__body {
      margin-bottom: 20px;
    }
    .footer__body > h3 {
      font-size: 18px;
      margin-bottom: 15px;
    }

    .footer__content > span {
      font-size: 12.8px;
      font-weight: 300;
    }

    .footer__content {
      /* border:1px solid black; */
      width: 160px;
    }
    .footer__container {
      padding-top: 18px;
      padding-bottom: 0;
    }
    .footer__containerbody {
      /* border: 1px solid white; */
      padding: 10px 0 10px 20px;
      margin-left: 1%;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
    .footer__main {
      padding: 0;
    }
    .footer__download {
      margin-bottom: 14px;
    }
    .footer__socialIcons {
      margin: 1px 0;
    }
    .footer__socials {
      margin-top: 1rem;
    }
    .footer__subscribe > input {
      /* position: absolute; */
      width: 130%;
      /* border: 5px solid black; */
      border-radius: 20px;
      height: 45px;
    }
    .footer__subscribe > button {
      font-size: 13px;
      padding: 4px 30px;
    }
    .footer__newsletter > span {
      font-size: 16px;
    }

    /* .footer__versions {
      padding: 0.5rem 5rem 10% 5rem;
    } */
  }

 
}
</style>
